import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { alfredClientService } from "@/services/alfred-client-service"
import type { AlfredClientConfig, CreateAlfredClientRequest, UpdateAlfredClientRequest } from "@/types/alfred-client"

export function useAlfredClients() {
  return useSWR(["alfred", "clients"], () => alfredClientService.getAll(), {
    revalidateOnFocus: false,
  })
}

export function useCreateAlfredClient() {
  return useSWRMutation(
    ["alfred", "clients"],
    async (_key: string[], { arg }: { arg: CreateAlfredClientRequest }): Promise<AlfredClientConfig> => {
      return alfredClientService.create(arg)
    },
  )
}

export function useUpdateAlfredClient() {
  return useSWRMutation(
    ["alfred", "clients"],
    async (
      _key: string[],
      { arg }: { arg: { id: number; data: UpdateAlfredClientRequest } },
    ): Promise<AlfredClientConfig> => {
      return alfredClientService.update(arg.id, arg.data)
    },
  )
}

export function useDeleteAlfredClient() {
  return useSWRMutation(
    ["alfred", "clients"],
    async (_key: string[], { arg }: { arg: number }): Promise<void> => {
      return alfredClientService.delete(arg)
    },
  )
}
